import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const HotspotClicksChart = ({ data }) => {
  const colors = ['var(--color-accent)', 'var(--color-success)', 'var(--color-warning)', 'var(--color-destructive)', 'var(--color-secondary)'];
  
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-elevation-lg">
          <p className="text-sm font-medium text-foreground mb-1">{payload?.[0]?.payload?.name}</p>
          <div className="flex items-center justify-between gap-4 text-xs">
            <span className="text-muted-foreground">Clicks:</span>
            <span className="font-semibold text-foreground">{payload?.[0]?.value?.toLocaleString()}</span>
          </div>
          <div className="flex items-center justify-between gap-4 text-xs mt-1">
            <span className="text-muted-foreground">CTR:</span>
            <span className="font-semibold text-foreground">{payload?.[0]?.payload?.ctr}%</span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <div className="mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Hotspot Click-Through Rates</h3>
        <p className="text-xs md:text-sm text-muted-foreground mt-1">Top performing interactive elements</p>
      </div>
      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Hotspot Clicks Bar Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 40 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '11px' }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="clicks" radius={[8, 8, 0, 0]}>
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors?.[index % colors?.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HotspotClicksChart;